import React from 'react';
import styled from 'styled-components';
import moment from 'moment';

import { useLanguage } from '../../../../Context/LanguageContext';
import { useTheme } from '../../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../../Styles/theme';

export default function PartnerGymRefundInfoView(props) {
  const { data } = props;
  const { t } = useLanguage();

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  function decidePriceView() {
    if (data.refundCardPrice === 0) return data.refundCashPrice.toLocaleString('ko-KR') + ' - ' + t('memberDetail.payCash');
    else if (data.refundCashPrice === 0) return data.refundCardPrice.toLocaleString('ko-KR') + ' - ' + t('memberDetail.payCard');
    else return (data.refundCardPrice + data.refundCashPrice).toLocaleString('ko-KR') + ' - ' + t('memberDetail.payCombined');
  }

  return (
    <TopLevelWrapper>
      <ComponentBox>
        <TotalTextWrapper>
          <TextWrapper width={55}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.white} cursor='pointer'>{t('partnerGym.history.refundComplete')}</Text>
          </TextWrapper>
          <TextWrapper width={65}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.white} cursor='pointer'>{moment(data.refundApprovalDate).format(t('partnerGym.history.dateFormat'))}</Text>
          </TextWrapper>
          <TextWrapper width={148}>
            {(() => {
              const result = decidePriceView();
              const dashIdx = result.indexOf(' - ');
              if (dashIdx === -1) return <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.white} cursor='pointer'>{result}</Text>;
              return (
                <PriceRow>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.white} cursor='pointer' style={{ flexShrink: 0 }}>{result.slice(0, dashIdx)}</Text>
                  <PaymentMethodText color={theme.white}>{result.slice(dashIdx)}</PaymentMethodText>
                </PriceRow>
              );
            })()}
          </TextWrapper>
          <TextWrapper width={403}>
            <EllipsisText color={theme.white}>{data.reason}</EllipsisText>
          </TextWrapper>
        </TotalTextWrapper>
      </ComponentBox>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: flex-start;

  width: 100%;
`;

const ComponentBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: -35px;

  width: 836px;
  height: 87px;

  border-radius: 0px 10px 12px 12px;
  background-color: ${props => props.theme.pointRedAlpha50};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const TotalTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-left: 20px;
  margin-top: 50px;

  gap: 10px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-right: 8px;

  width: ${props => props.width}px;
  height: 20px;

  overflow: hidden;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }
`;

const PriceRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 0;
  overflow: hidden;
`;

const PaymentMethodText = styled.span`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.color};

  margin: 0;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const EllipsisText = styled.span`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.color};

  margin: 0;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
